<script>
import axios from 'axios';
import Select from './Select.vue';
import MixinsVue from '../mixins/Vue.js';

// Shared across every <select-timezone> instance on the page (the header modal
// + the footer selector both mount one). The timezone list is static, so a
// single in-flight request is reused instead of firing one fetch per instance.
let timezonesRequest = null;

export default {
    extends: Select,
    components: {
        Select,
    },
    props: {
        originalInputPlaceholderText: String,
        dropdownContainerId: String,
        user: {
            type: Object,
            default: function () {
                return appData.page.vars.user;
            },
        },
    },
    data() {
        return {
            mixins: MixinsVue.methods.vue,
            options: [],
            timezones: [],
            selectedTimezone: null,
            selectInputName: 'select-timezone',
            selectOption: 'select-timezone',
            hasBeenLoaded: false,
            token: document.querySelector('meta[name="csrf-token"]').content,
        };
    },
    computed: {
        inputPlaceholderText: function () {
            let userTimezone = this.app.locale.getUserTimezone();
            let userUtcOffset =
                this.mixins.methods.convertTimezoneToUtcOffset(userTimezone);
            let selectPlaceholder = 'UTC';
            selectPlaceholder +=
                userUtcOffset >= 0 ? '+' + userUtcOffset : userUtcOffset;
            selectPlaceholder += ' (' + userTimezone + ')';
            return selectPlaceholder;
        },
    },
    watch: {
        // Lazy-load the timezone list the first time the dropdown opens, so no
        // request fires on page load — the list is only needed on interaction.
        // `opened` is the base Select dropdown state; `hasBeenLoaded` + the
        // shared request guard against repeats.
        opened(isOpen) {
            if (isOpen) {
                this.loadTimezones();
            }
        },
        selectInputValue(value) {
            this.filterOptions(value);
        },
    },
    methods: {
        select(locale) {
            this.selectedLocale = locale;
            this.selectInputValue = this.optionLabel(locale);
            Select.methods.select.call(this, locale);
        },
        optionLabel(option) {
            return option.full_label;
        },
        loadTimezones() {
            // Avoid loading timezones several times for this instance.
            if (this.hasBeenLoaded) {
                return;
            }

            // Reuse a single request shared by all instances (see module top).
            if (!timezonesRequest) {
                timezonesRequest = axios
                    .get('/api/timezones', {
                        headers: {
                            'X-CSRF-TOKEN': this.token,
                        },
                    })
                    .then((success) => JSON.parse(success.data));
            }

            timezonesRequest.then(
                (timezones) => {
                    this.options = this.timezones = timezones;
                    this.hasBeenLoaded = true;
                },
                (error) => {
                    // Log error on the console for debug purpose
                    console.error(error.response && error.response.status);
                    console.error(error.message);
                }
            );
        },
        filterOptions(string) {
            // Allow timezones filtering when typing in the select input
            string = string && string.trim();
            if (!string) {
                this.options = this.timezones;
            } else {
                string = this.app.string.slugify(string);
                this.options = this.timezones.filter((timezone) => {
                    // Ignore special chars.
                    let label = this.app.string.slugify(
                        this.optionLabel(timezone)
                    );
                    return !timezone.id || label.indexOf(string) !== -1;
                });
            }
        },
    },
};
</script>
